module.exports = __webpack_public_path__ + "img/truc4.50d836f4.png";